import React from "react";
import { Icon } from "@chakra-ui/react";

export const ArrowLeftIcon = ({ ...props }) => {
  return (
    <Icon
      as="svg"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.41 7.41006L14 6.00006L8 12.0001L14 18.0001L15.41 16.5901L10.83 12.0001L15.41 7.41006Z"
        fill="currentColor"
      />
    </Icon>
  );
};
